'use client';

import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { Draggable } from 'gsap/Draggable';
import { Text, Image } from '@weareconceptstudio/core';

//* HOC's
import { withUIContext } from '@/context';

// //* Lottie
// import lottie1 from '../../../../../public/lottie/a.json';
// import lottie2 from '../../../../../public/lottie/b.json';
// import lottie3 from '../../../../../public/lottie/c.json';
// import lottie4 from '../../../../../public/lottie/d.json';

//* Style
import InfoStyle from './style';

const Info = ({ data, className, winWidth, loadAnimation }) => {
	// //! Lottie Container
	// const lottieContainer = [lottie4, lottie3, lottie1, lottie2];
	const iconContainer = ['freshness', 'fast-delivery', 'chef', 'delivery'];

	//! Refs
	const wrapper = useRef();
	const draggableInstance = useRef();
	const draggableContainer = useRef();

	useEffect(() => {
		gsap.registerPlugin(Draggable);
		if (loadAnimation)
			gsap.to('.info-section-wrapper', {
				duration: 0.6,
				delay: 0.9,
				ease: 'power1.out',
				color: 'var(--mainColor)',
			});
		const allImage = wrapper.current.querySelectorAll('.image-wrapper-icon');

		if (loadAnimation) gsap.to([...allImage], { opacity: 1, duration: 0.6, delay: 0.9, ease: 'power1.out' });

		winWidth < 1280
			? (draggableInstance.current = Draggable.create(draggableContainer.current, {
					type: 'x',
					bounds: wrapper.current,
					inertia: true,
				}))
			: null;

		return () => {
			if (draggableInstance.current) {
				draggableInstance.current.forEach((instance) => instance.kill());
			}
		};
	}, [winWidth, loadAnimation]);

	return (
		<InfoStyle className={`info-section-wrapper`}>
			<div
				ref={wrapper}
				className='wrapper-draggable'>
				<div
					ref={draggableContainer}
					className='wrapper-container'>
					{data?.length > 0
						? data.map((item, i) => {
								return (
									<div
										key={i}
										className='wrapper-image-title'>
										{/* <LottieAnimation
											className={'image-wrapper-icon'}
											loop={true}
											autoplay={true}
											isPlay={true}
											animData={lottieContainer[i]}
										/> */}

										{/* <Icon
											className={'image-wrapper-icon'}
											name={iconContainer[i]}
										/> */}

										<Image
											className={'image-wrapper-icon'}
											alt={item.icon.alt}
											src={item.icon.src}
										/>

										{/* <Text className={'h6 text-title uppercase'}>{item.title}</Text> */}
										<Text className={'p p1 text-title uppercase'}>{item.title}</Text>
									</div>
								);
							})
						: null}
				</div>
			</div>
		</InfoStyle>
	);
};

export default withUIContext(Info, ['winWidth', 'loadAnimation']);
